export const initialState = {
  newBusiness: {},
  businesses: [],
  updateBusiness: {},
  business: {},
  newTransaction: {},
  nextTokens: { 1: null },
  businessNextToken: { 1: null },
  loading: false,
  error: null,
  businessError: null,
  transactions: [],
  transaction: {},
  updateTransaction: {},
  cashbook: {},
  newcashbook: {},
  taxDetail: {},
  taxDetailLoading: false,
  taxDetailError: null,
  deleteLoading: false,
  deletedId: null,
  submitError: null,
  submitLoading: false,
  newTransactionLoading: false,
  newTransactionError: null,
  uploadLoading: false,
  uploadError: null,
  uploadSuccess: false,
  excelTransactions: [],
  storageRequest: null,
  uploadRequest: null,
  request: null,
  newExcelTransactions: [],
  excelTransactionsLoading: false,
  excelTransactionsError: null,
  excelTransactionsSuccess: false,
  businessPartners: [],
  businessPartnerLoading: false,
  businessPartnerNextTokens: { 1: null },
  businessPartnerError: null,
  newPartner: "",
  newPartnerLoading: false,
  newPartnerError: null,
  partnerID: "",
  deletedID: "",
  cashbookStats: {},
  cashbookStatsLoading: false,
  cashbookStatsError: null,
  partnerCashTransactionsLoading: false,
  partnerCashTransactionsError: null,
  partnerCashTransactions: [],
  partnerCashTransactionsNextTokens: { 1: null },
  updatePartnerLoading: false,
  updatePartnerError: null,
  deletePartnerLoading: false,
  deletePartnerError: null,
  employees: [],
  employeesLoading: false,
  employeesError: null,
  employeeNextTokens: { 1: null },
  newEmployee: {},
  newEmployeeLoading: false,
  newEmployeeError: null,
  updateEmployee: {},
  updateEmployeeLoading: false,
  updateEmployeeError: null,
  deletedEmployeeId: "",
  deleteEmployeeLoading: false,
  deleteEmployeeError: null,
  employee: {},
  getEmployeeLoading: false,
  getEmployeeError: null,
  newAllowancesLoading: false,
  newAllowancesError: null,
  newAllowances: [],
  updateAllowancesLoading: false,
  updateAllowancesError: null,
  updatedAllowances: [],
  deductions: [],
  deductionsLoading: false,
  deductionsError: null,
  attendances: [],
  attendancesLoading: false,
  attendancesError: null,
  attendanceNextTokens: { 1: null },
  newAttendance: {},
  newAttendanceLoading: false,
  newAttendanceError: null,
  updateAttendance: {},
  updateAttendanceLoading: false,
  updateAttendanceError: null,
  deleteAttendanceLoading: false,
  deleteAttendanceError: null,
  deletedAttendanceId: null,
  calendars: [],
  calendarsLoading: false,
  calendarsError: null,
  calendarNextTokens: { 1: null },
  newCalendar: {},
  newCalendarLoading: false,
  newCalendarError: null,
  updateCalendar: {},
  updateCalendarLoading: false,
  updateCalendarError: null,
  newCalendarHoliday: {},
  newCalendarHolidayLoading: false,
  newCalendarHolidayError: null,
  deletedHolidayId: null,
  deleteHolidayLoading: false,
  deleteHolidayError: null,
  attendanceSummary: {},
  attendanceSummaryLoading: false,
  attendanceSummaryError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_CREATE_BUSINESS":
      return {
        ...state,
        newBusiness: {},
        error: null,
        loading: true,
      };
    case "SUCCESS_CREATE_BUSINESS":
      return {
        ...state,
        newBusiness: action.payload.business,
        businesses: [action.payload.business, ...state.businesses],
        loading: false,
      };
    case "ERROR_CREATE_BUSINESS":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_GET_BUSINESS":
      return {
        ...state,
        business: {},
        businessError: null,
        loading: true,
      };
    case "GET_BUSINESS_SUCCESS":
      return {
        ...state,
        business: action.payload.business,
        loading: false,
      };
    case "GET_BUSINESS_ERROR":
      return {
        ...state,
        loading: false,
        businessError: action.payload.error,
      };
    case "REQUEST_LIST_BUSINESS":
      return {
        ...state,
        businesses: [],
        loading: true,
        error: null,
      };
    case "SUCCESS_LIST_BUSINESS":
      return {
        ...state,
        businesses: action.payload.items,
        loading: false,
      };
    case "ERROR_LIST_BUSINESS":
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    case "REQUEST_UPDATE_BUSINESS":
      return {
        ...state,
        updateBusiness: {},
        error: null,
        loading: true,
      };
    case "UPDATE_BUSINESS_SUCCESS":
      return {
        ...state,
        updateBusiness: action.payload.business,
        businesses: state.businesses.map((business) => {
          if (business.id === action.payload.business.id) {
            return {
              ...action.payload.business,
              value: action.payload.business.id,
              label: action.payload.business.name,
            };
          }
          return business;
        }),
        loading: false,
      };
    case "ERROR_UPDATE_BUSINESS":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "CLEAR_UPDATE_BUSINESS":
      return {
        ...state,
        updateBusiness: {},
      };
    case "CLEAR_UPDATE_BUSINESS_ERROR":
      return {
        ...state,
        error: null,
      };
    case "REQUEST_GET_TAX_DETAIL":
      return {
        ...state,
        taxDetail: {},
        taxDetailLoading: true,
        taxDetailError: null,
      };
    case "GET_TAX_DETAIL_SUCCESS":
      return {
        ...state,
        taxDetail: action.payload.taxDetail,
        taxDetailLoading: false,
      };
    case "GET_TAX_DETAIL_ERROR":
      return {
        ...state,
        taxDetailLoading: false,
        taxDetailError: action.error,
      };
    case "CLEAR_TAX_DETAIL":
      return {
        ...state,
        taxDetail: {},
        taxDetailError: null,
        taxDetailLoading: false,
      };
    case "RESET_NEW_BUSINESS":
      return {
        ...state,
        newBusiness: {},
      };
    case "REQUEST_CREATE_BUSINESS_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        newTransaction: {},
        newTransactionError: null,
        newTransactionLoading: true,
      };
    case "SUCCESS_CREATE_BUSINESS_TRANSACTION":
      return {
        ...state,
        request: null,
        newTransaction: action.payload.transaction,
        transactions: [action.payload.transaction, ...state.transactions],
        newTransactionLoading: false,
      };
    case "ERROR_CREATE_BUSINESS_TRANSACTION":
      return {
        ...state,
        request: null,
        newTransactionLoading: false,
        newTransactionError: action.error,
      };
    case "REQUEST_GET_BUSINESS_TRANSACTION":
      return {
        ...state,
        transaction: {},
        error: null,
        loading: true,
      };
    case "GET_BUSINESS_TRANSACTION_SUCCESS":
      return {
        ...state,
        transaction: action.payload.transaction,
        loading: false,
      };
    case "GET_BUSINESS_TRANSACTION_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case "REQUEST_UPDATE_BUSINESS_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        updateTransaction: {},
        submitError: null,
        submitLoading: true,
      };
    case "UPDATE_BUSINESS_TRANSACTION_SUCCESS":
      return {
        ...state,
        request: null,
        updateTransaction: action.payload.transaction,
        transactions: state.transactions.map((transaction) =>
          transaction.id === action.payload.transaction.id
            ? action.payload.transaction
            : transaction,
        ),
        partnerCashTransactions: state.partnerCashTransactions.map(
          (partnerCashTransaction) => {
            if (partnerCashTransaction.id === action.payload.transaction.id) {
              return action.payload.transaction;
            }
            return partnerCashTransaction;
          },
        ),
        loading: false,
        submitLoading: false,
      };
    case "ERROR_UPDATE_BUSINESS_TRANSACTION":
      return {
        ...state,
        request: null,
        submitLoading: false,
        submitError: action.error,
      };
    case "REQUEST_DELETE_CASH_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        deleteLoading: true,
        submitError: null,
      };
    case "DELETE_CASH_TRANSACTION_SUCCESS":
      return {
        ...state,
        transactions: state.transactions.filter(
          (transaction) => transaction.id !== action.payload.id,
        ),
        partnerCashTransactions: state.partnerCashTransactions.filter(
          (partnerCashTransaction) =>
            partnerCashTransaction.id !== action.payload.id,
        ),
        deletedId: action.payload.id,
        deleteLoading: false,
        request: null,
      };
    case "DELETE_CASH_TRANSACTION_ERROR":
      return {
        ...state,
        deleteLoading: false,
        submitError: action.error,
        request: null,
      };
    case "REQUEST_LIST_BUSINESS_TRANSACTION":
      return {
        ...state,
        request: action.payload.request,
        transactions: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        error: null,
        loading: true,
      };
    case "SUCCESS_LIST_BUSINESS_TRANSACTION":
      return {
        ...state,
        transactions: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        loading: false,
      };
    case "ERROR_LIST_BUSINESS_TRANSACTION":
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case "RESET_NEW_BUSINESS_TRANSACTION":
      return {
        ...state,
        newTransaction: {},
        newTransactionError: null,
      };
    case "RESET_UPDATE_BUSINESS_TRANSACTION":
      return {
        ...state,
        updateTransaction: {},
        submitError: null,
      };
    case "REQUEST_CASHBOOK_BUSINESS":
      return {
        ...state,
        cashbook: {},
        error: null,
        loading: true,
      };
    case "SUCCESS_CASHBOOK_BUSINESS":
      return {
        ...state,
        cashbook: action.payload.cashbook,
        loading: false,
      };
    case "ERROR_CASHBOOK_BUSINESS":
      return {
        ...state,
        cashbook: {},
      };
    case "CLEAR_CASHBOOK_BUSINESS":
      return {
        ...state,
        cashbook: {},
      };
    case "CLEAR_GET_BUSINESS":
      return {
        ...state,
        businessError: null,
        business: {},
      };
    case "REQUEST_UPLOAD_DOCUMENT_EXCEL":
      return {
        ...state,
        uploadLoading: true,
        uploadError: null,
        uploadSuccess: false,
        uploadRequest: null,
        storageRequest: null,
      };
    case "UPLOAD_DOCUMENT_EXCEL_PENDING":
      return {
        ...state,
        uploadLoading: true,
        uploadError: null,
        uploadSuccess: false,
        storageRequest: action.payload.upload,
        progressUpload: action.payload.progress,
      };
    case "UPLOAD_DOCUMENT_EXCEL_SUCCESS":
      return {
        ...state,
        uploadLoading: false,
        uploadSuccess: true,
        excelTransactions: action.payload.excelTransactions,
      };
    case "UPLOAD_DOCUMENT_EXCEL_ERROR":
      return {
        ...state,
        uploadLoading: false,
        uploadError: action.error,
      };
    case "REQUEST_CREATE_EXCEL_TRANSACTIONS":
      return {
        ...state,
        newExcelTransactions: [],
        excelTransactionsLoading: true,
        excelTransactionsSuccess: false,
        excelTransactionsError: null,
      };
    case "SUCCESS_CREATE_EXCEL_TRANSACTIONS":
      return {
        ...state,
        newExcelTransactions: action.payload.newExcelTransactions,
        excelTransactionsSuccess: true,
        excelTransactionsLoading: false,
      };
    case "ERROR_CREATE_EXCEL_TRANSACTIONS":
      return {
        ...state,
        excelTransactionsError: action.error,
        excelTransactionsLoading: false,
      };
    case "CLEAR_UPLOAD_DOCUMENT_EXCEL":
      return {
        ...state,
        uploadError: null,
        excelTransactions: [],
        uploadSuccess: false,
      };
    case "CLEAR_CREATE_EXCEL_TRANSACTIONS":
      return {
        ...state,
        excelTransactionsError: null,
        newExcelTransactions: [],
        excelTransactionsSuccess: false,
      };
    case "REQUEST_LIST_BUSINESS_PARTNER":
      return {
        ...state,
        businessPartnerLoading: true,
        businessPartnerError: null,
        businessPartners: [],
        request: action.payload.request,
        businessPartnerNextTokens:
          action.payload.page === 1
            ? initialState.businessPartnerNextTokens
            : state.businessPartnerNextTokens,
      };
    case "LIST_BUSINESS_PARTNER_SUCCESS":
      return {
        ...state,
        request: null,
        businessPartnerLoading: false,
        businessPartners: action.payload.items,
        businessPartnerNextTokens: {
          ...state.businessPartnerNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_BUSINESS_PARTNER_ERROR":
      return {
        ...state,
        request: null,
        businessPartnerLoading: false,
        businessPartnerError: action.error,
      };
    case "REQUEST_CREATE_BUSINESS_PARTNER":
      return {
        ...state,
        request: action.payload.request,
        newPartner: "",
        newPartnerError: null,
        newPartnerLoading: true,
      };
    case "SUCCESS_CREATE_BUSINESS_PARTNER":
      return {
        ...state,
        request: null,
        newPartner: action.payload.partner,
        businessPartners: [action.payload.partner, ...state.businessPartners],
        newPartnerLoading: false,
      };
    case "ERROR_CREATE_BUSINESS_PARTNER":
      return {
        ...state,
        request: null,
        newPartnerLoading: false,
        newPartnerError: action.error,
      };
    case "REQUEST_UPDATE_BUSINESS_PARTNER":
      return {
        ...state,
        request: action.payload.request,
        partnerID: "",
        updatePartnerError: null,
        updatePartnerLoading: true,
      };
    case "UPDATE_BUSINESS_PARTNER_SUCCESS":
      const { partner } = action.payload;
      const updatedPartnersUpdate = state.businessPartners.map(
        (businessPartner) =>
          businessPartner.id === partner.id ? partner : businessPartner,
      );
      return {
        ...state,
        request: null,
        partnerID: partner.id,
        updatePartnerLoading: false,
        businessPartners: updatedPartnersUpdate,
      };
    case "ERROR_UPDATE_BUSINESS_PARTNER":
      return {
        ...state,
        request: null,
        updatePartnerLoading: false,
        updatePartnerError: action.error,
      };
    case "REQUEST_DELETE_BUSINESS_PARTNER":
      return {
        ...state,
        request: action.payload.request,
        deletePartnerLoading: true,
        deletePartnerError: null,
        deletedID: "",
      };
    case "DELETE_BUSINESS_PARTNER_SUCCESS":
      return {
        ...state,
        request: null,
        businessPartners: state.businessPartners.filter(
          (partner) => partner.id !== action.payload.id,
        ),
        deletePartnerLoading: false,
        deletedID: action.payload.id,
      };
    case "DELETE_BUSINESS_PARTNER_ERROR":
      return {
        ...state,
        request: null,
        deletePartnerLoading: false,
        deletePartnerError: action.error,
      };
    case "REQUEST_GET_CASHBOOK_STATS":
      return {
        ...state,
        cashbookStatsRequest: action.payload.cashbookStatsRequest,
        cashbookStats: {},
        cashbookStatsError: null,
        cashbookStatsLoading: true,
      };
    case "GET_CASHBOOK_STATS_SUCCESS":
      return {
        ...state,
        cashbookStatsRequest: null,
        cashbookStats: action.payload.stats,
        cashbookStatsLoading: false,
      };
    case "GET_CASHBOOK_STATS_ERROR":
      return {
        ...state,
        cashbookStatsRequest: null,
        cashbookStatsLoading: false,
        cashbookStatsError: action.payload.error,
      };
    case "REQUEST_LIST_PARTNER_CASH_TRANSACTION":
      return {
        ...state,
        partnerCashTransactionsLoading: true,
        partnerCashTransactionsError: null,
        partnerCashTransactions: [],
        request: action.payload.request,
        partnerCashTransactionsNextTokens:
          action.payload.page === 1
            ? initialState.partnerCashTransactionsNextTokens
            : state.partnerCashTransactionsNextTokens,
      };
    case "SUCCESS_LIST_PARTNER_CASH_TRANSACTION":
      return {
        ...state,
        partnerCashTransactionsLoading: false,
        partnerCashTransactions: action.payload.items,
        partnerCashTransactionsNextTokens: {
          ...state.partnerCashTransactionsNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "ERROR_LIST_PARTNER_CASH_TRANSACTION":
      return {
        ...state,
        partnerCashTransactionsLoading: false,
        partnerCashTransactionsError: action.payload.error,
      };
    case "CLEAR_BUSINESS_PARTNER":
      return {
        ...state,
        newPartner: "",
        partnerID: "",
      };
    case "CLEAR_BUSINESS_PARTNER_ERROR":
      return {
        ...state,
        newPartnerError: null,
        deletePartnerError: null,
        updatePartnerError: null,
      };
    case "CLEAR_BUSINESS_TRANSACTION":
      return {
        ...state,
        transaction: {},
        newTransaction: {},
        deletedId: "",
      };
    case "CLEAR_BUSINESS_TRANSACTION_ERROR":
      return {
        ...state,
        submitError: null,
        nextError: null,
      };
    case "REQUEST_LIST_BUSINESS_EMPLOYEE":
      return {
        ...state,
        request: action.payload.request,
        employees: [],
        employeeNextTokens:
          action.payload.page === 1
            ? initialState.employeeNextTokens
            : state.employeeNextTokens,
        employeesLoading: true,
        employeesError: null,
      };
    case "LIST_BUSINESS_EMPLOYEE_SUCCESS":
      return {
        ...state,
        request: null,
        employeesLoading: false,
        employees: action.payload.items,
        employeeNextTokens: {
          ...state.employeeNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "LIST_BUSINESS_EMPLOYEE_ERROR":
      return {
        ...state,
        request: null,
        employeesLoading: false,
        employeesError: action.error,
      };
    case "REQUEST_CREATE_BUSINESS_EMPLOYEE":
      return {
        ...state,
        request: action.payload.request,
        newEmployee: {},
        newEmployeeLoading: true,
        newEmployeeError: null,
      };
    case "CREATE_BUSINESS_EMPLOYEE_SUCCESS":
      return {
        ...state,
        request: null,
        newEmployeeLoading: false,
        newEmployee: action.payload.employee,
      };
    case "CREATE_BUSINESS_EMPLOYEE_ERROR":
      return {
        ...state,
        request: null,
        newEmployeeLoading: false,
        newEmployeeError: action.error,
      };
    case "REQUEST_UPDATE_BUSINESS_EMPLOYEE":
      return {
        ...state,
        request: action.payload.request,
        updateEmployee: {},
        updateEmployeeLoading: true,
        updateEmployeeError: null,
      };
    case "UPDATE_BUSINESS_EMPLOYEE_SUCCESS": {
      const { employee } = action.payload;
      const updatedEmployees = state.employees.map((existingEmployee) =>
        existingEmployee.id === employee.id ? employee : existingEmployee,
      );
      return {
        ...state,
        request: null,
        updateEmployeeLoading: false,
        updateEmployee: employee,
        employees: updatedEmployees,
      };
    }
    case "UPDATE_BUSINESS_EMPLOYEE_ERROR":
      return {
        ...state,
        request: null,
        updateEmployeeLoading: false,
        updateEmployeeError: action.error,
      };
    case "REQUEST_DELETE_BUSINESS_EMPLOYEE":
      return {
        ...state,
        request: action.payload.request,
        deletedEmployeeId: "",
        deleteEmployeeLoading: true,
        deleteEmployeeError: null,
      };
    case "DELETE_BUSINESS_EMPLOYEE_SUCCESS":
      return {
        ...state,
        request: null,
        deletedEmployeeId: action.payload.id,
        employees: state.employees.filter(
          (employee) => employee.id !== action.payload.id,
        ),
        deleteEmployeeLoading: false,
      };
    case "DELETE_BUSINESS_EMPLOYEE_ERROR":
      return {
        ...state,
        request: null,
        deleteEmployeeLoading: false,
        deleteEmployeeError: action.error,
      };
    case "REQUEST_GET_BUSINESS_EMPLOYEE":
      return {
        ...state,
        request: action.payload.request,
        employee: {},
        getEmployeeLoading: true,
        getEmployeeError: null,
      };
    case "GET_BUSINESS_EMPLOYEE_SUCCESS":
      return {
        ...state,
        request: null,
        employee: action.payload.employee,
        getEmployeeLoading: false,
      };
    case "GET_BUSINESS_EMPLOYEE_ERROR":
      return {
        ...state,
        request: null,
        getEmployeeLoading: false,
        getEmployeeError: action.error,
      };
    case "REQUEST_CREATE_EMPLOYEE_ALLOWANCES":
      return {
        ...state,
        request: action.payload.request,
        newAllowancesLoading: true,
        newAllowancesError: null,
        newAllowances: [],
      };
    case "CREATE_EMPLOYEE_ALLOWANCES_SUCCESS": {
      const employeeIndex = state.employees.findIndex(
        (emp) => emp.id === action.payload.employeeID,
      );

      const updatedEmployees = [...state.employees];
      const currentEmployee = updatedEmployees[employeeIndex];

      if (currentEmployee) {
        const existingAllowances = currentEmployee?.allowances?.items || [];
        const combinedAllowances = [
          ...existingAllowances,
          ...action.payload.allowances,
        ];

        updatedEmployees[employeeIndex] = {
          ...currentEmployee,
          allowances: {
            ...currentEmployee.allowances,
            items: combinedAllowances,
          },
        };
      }

      let updatedEmployee = state.employee;
      if (state.employee?.id === action.payload.employeeID) {
        const existingAllowances = state.employee?.allowances?.items || [];
        const combinedAllowances = [
          ...existingAllowances,
          ...action.payload.allowances,
        ];

        updatedEmployee = {
          ...state.employee,
          allowances: {
            ...state.employee.allowances,
            items: combinedAllowances,
          },
        };
      }

      return {
        ...state,
        request: null,
        newAllowancesLoading: false,
        newAllowances: action.payload.allowances,
        employees: updatedEmployees,
        employee: updatedEmployee,
      };
    }
    case "ERROR_CREATE_EMPLOYEE_ALLOWANCES":
      return {
        ...state,
        request: null,
        newAllowancesLoading: false,
        newAllowancesError: action.error,
      };
    case "REQUEST_UPDATE_EMPLOYEE_ALLOWANCES":
      return {
        ...state,
        request: action.payload.request,
        updateAllowancesLoading: true,
        updateAllowancesError: null,
        updatedAllowances: [],
      };
    case "UPDATE_EMPLOYEE_ALLOWANCES_SUCCESS":
      const employeeIndex = state.employees.findIndex(
        (emp) => emp.id === action.payload.allowances.employeeID,
      );

      const updatedEmployees = [...state.employees];
      const currentEmployee = updatedEmployees[employeeIndex];

      if (currentEmployee) {
        updatedEmployees[employeeIndex] = {
          ...currentEmployee,
          allowances: {
            ...currentEmployee.allowances,
            items: action.payload.allowances.allowances,
          },
        };
      }

      let updatedEmployee = state.employee;
      if (state.employee?.id === action.payload.allowances.employeeID) {
        updatedEmployee = {
          ...state.employee,
          allowances: {
            ...state.employee.allowances,
            items: action.payload.allowances.allowances,
          },
        };
      }

      return {
        ...state,
        request: null,
        updateAllowancesLoading: false,
        updatedAllowances: action.payload.allowances,
        employees: updatedEmployees,
        employee: updatedEmployee,
      };
    case "UPDATE_EMPLOYEE_ALLOWANCES_ERROR":
      return {
        ...state,
        request: null,
        updateAllowancesLoading: false,
        updateAllowancesError: action.error,
      };
    case "REQUEST_UPDATE_EMPLOYEE_DEDUCTIONS":
      return {
        ...state,
        request: action.payload.request,
        deductions: [],
        deductionsLoading: true,
        deductionsError: null,
      };

    case "UPDATE_EMPLOYEE_DEDUCTIONS_SUCCESS": {
      const employeeIndex = state.employees.findIndex(
        (emp) => emp.id === action.payload.deductions.employeeID,
      );

      const updatedEmployees = [...state.employees];
      const currentEmployee = updatedEmployees[employeeIndex];

      if (currentEmployee) {
        updatedEmployees[employeeIndex] = {
          ...currentEmployee,
          deductions: {
            ...currentEmployee.deductions,
            items: action.payload.deductions.deductions,
          },
        };
      }

      let updatedEmployee = state.employee;
      if (state.employee?.id === action.payload.deductions.employeeID) {
        updatedEmployee = {
          ...state.employee,
          deductions: {
            ...state.employee.deductions,
            items: action.payload.deductions.deductions,
          },
        };
      }

      return {
        ...state,
        request: null,
        deductionsLoading: false,
        deductions: action.payload.deductions,
        employees: updatedEmployees,
        employee: updatedEmployee,
      };
    }
    case "UPDATE_EMPLOYEE_DEDUCTIONS_ERROR":
      return {
        ...state,
        request: null,
        deductionsLoading: false,
        deductionsError: action.error,
      };
    case "CLEAR_BUSINESS_EMPLOYEE":
      return {
        ...state,
        newEmployee: {},
        newEmployeeError: null,
        updateEmployee: {},
        updateEmployeeError: null,
        deletedEmployeeId: "",
        deleteEmployeeError: null,
        newAllowances: [],
        newAllowancesError: null,
        updatedAllowances: [],
        updateAllowancesError: null,
        deductions: [],
        deductionsError: null,
        updateAttendance: null,
        updateAttendanceLoading: false,
        updateAttendanceError: null,
      };

    case "REQUEST_LIST_EMPLOYEE_ATTENDANCE":
      return {
        ...state,
        request: action.payload.request,
        attendances: [],
        attendanceNextTokens:
          action.payload.page === 1
            ? initialState.attendanceNextTokens
            : state.attendanceNextTokens,
        attendancesLoading: true,
        attendancesError: null,
      };

    case "LIST_EMPLOYEE_ATTENDANCE_SUCCESS":
      return {
        ...state,
        request: null,
        attendancesLoading: false,
        attendances: action.payload.items,
        attendanceNextTokens: {
          ...state.attendanceNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };

    case "LIST_EMPLOYEE_ATTENDANCE_ERROR":
      return {
        ...state,
        request: null,
        attendancesLoading: false,
        attendancesError: action.error,
      };

    case "REQUEST_CREATE_EMPLOYEE_ATTENDANCE":
      return {
        ...state,
        request: action.payload.request,
        newAttendance: null,
        newAttendanceLoading: true,
        newAttendanceError: null,
      };

    case "CREATE_EMPLOYEE_ATTENDANCE_SUCCESS":
      return {
        ...state,
        request: null,
        newAttendanceLoading: false,
        newAttendance: action.payload.attendance,
        attendances: [action.payload.attendance, ...state.attendances],
      };

    case "CREATE_EMPLOYEE_ATTENDANCE_ERROR":
      return {
        ...state,
        request: null,
        newAttendanceLoading: false,
        newAttendanceError: action.error,
      };

    case "REQUEST_UPDATE_EMPLOYEE_ATTENDANCE":
      return {
        ...state,
        request: action.payload.request,
        updateAttendance: {},
        updateAttendanceLoading: true,
        updateAttendanceError: null,
      };

    case "UPDATE_EMPLOYEE_ATTENDANCE_SUCCESS":
      return {
        ...state,
        request: null,
        updateAttendanceLoading: false,
        updateAttendance: action.payload.attendance,
        attendances: state.attendances.map((attendance) =>
          attendance.id === action.payload.attendance.id
            ? action.payload.attendance
            : attendance,
        ),
      };

    case "UPDATE_EMPLOYEE_ATTENDANCE_ERROR":
      return {
        ...state,
        request: null,
        updateAttendanceLoading: false,
        updateAttendanceError: action.error,
      };

    case "REQUEST_DELETE_EMPLOYEE_ATTENDANCE":
      return {
        ...state,
        request: action.payload.request,
        deleteAttendanceLoading: true,
        deleteAttendanceError: null,
        deletedAttendanceId: null,
      };

    case "DELETE_EMPLOYEE_ATTENDANCE_SUCCESS":
      return {
        ...state,
        request: null,
        deleteAttendanceLoading: false,
        deletedAttendanceId: action.payload.id,
        attendances: state.attendances.filter(
          (attendance) => attendance.id !== action.payload.id,
        ),
      };

    case "DELETE_EMPLOYEE_ATTENDANCE_ERROR":
      return {
        ...state,
        request: null,
        deleteAttendanceLoading: false,
        deleteAttendanceError: action.error,
      };

    case "REQUEST_GET_EMPLOYEE_ATTENDANCE_SUMMARY":
      return {
        ...state,
        request: action.payload.request,
        attendanceSummary: {},
        attendanceSummaryLoading: true,
        attendanceSummaryError: null,
      };
    case "GET_EMPLOYEE_ATTENDANCE_SUMMARY_SUCCESS":
      return {
        ...state,
        request: null,
        attendanceSummaryLoading: false,
        attendanceSummary: action.payload.summary || {},
      };
    case "GET_EMPLOYEE_ATTENDANCE_SUMMARY_ERROR":
      return {
        ...state,
        request: null,
        attendanceSummaryLoading: false,
        attendanceSummaryError: action.error,
      };

    case "CLEAR_EMPLOYEE_ATTENDANCE":
      return {
        ...state,
        newAttendance: {},
        newAttendanceError: null,
        newAttendanceLoading: false,
        updateAttendance: {},
        updateAttendanceError: null,
        updateAttendanceLoading: false,
        deleteAttendanceLoading: false,
        deleteAttendanceError: null,
        deletedAttendanceId: null,
      };

    case "REQUEST_LIST_BUSINESS_CALENDAR":
      return {
        ...state,
        request: action.payload.request,
        calendars: [],
        calendarNextTokens:
          action.payload.page === 1
            ? initialState.calendarNextTokens
            : state.calendarNextTokens,
        calendarsLoading: true,
        calendarsError: null,
      };

    case "LIST_BUSINESS_CALENDAR_SUCCESS":
      return {
        ...state,
        request: null,
        calendarsLoading: false,
        calendars: action.payload.items,
        calendarNextTokens: {
          ...state.calendarNextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };

    case "LIST_BUSINESS_CALENDAR_ERROR":
      return {
        ...state,
        request: null,
        calendarsLoading: false,
        calendarsError: action.error,
      };

    case "REQUEST_CREATE_BUSINESS_CALENDAR":
      return {
        ...state,
        request: action.payload.request,
        newCalendar: {},
        newCalendarLoading: true,
        newCalendarError: null,
      };

    case "CREATE_BUSINESS_CALENDAR_SUCCESS":
      return {
        ...state,
        request: null,
        newCalendar: action.payload.calendar,
        newCalendarLoading: false,
        calendars: [...state.calendars, action.payload.calendar],
      };

    case "CREATE_BUSINESS_CALENDAR_ERROR":
      return {
        ...state,
        request: null,
        newCalendarLoading: false,
        newCalendarError: action.error,
      };

    case "REQUEST_UPDATE_BUSINESS_CALENDAR":
      return {
        ...state,
        request: action.payload.request,
        updateCalendar: {},
        updateCalendarLoading: true,
        updateCalendarError: null,
      };

    case "UPDATE_BUSINESS_CALENDAR_SUCCESS":
      return {
        ...state,
        request: null,
        updateCalendar: action.payload.calendar,
        updateCalendarLoading: false,
        calendars: state.calendars.map((calendar) =>
          calendar.id === action.payload.calendar.id
            ? {
                ...calendar,
                ...action.payload.calendar,
                holidays: action.payload.calendar.holidays ?? calendar.holidays,
              }
            : calendar,
        ),
      };

    case "UPDATE_BUSINESS_CALENDAR_ERROR":
      return {
        ...state,
        request: null,
        updateCalendarLoading: false,
        updateCalendarError: action.error,
      };

    case "CLEAR_BUSINESS_CALENDAR":
      return {
        ...state,
        newCalendar: {},
        newCalendarLoading: false,
        newCalendarError: null,
        updateCalendar: {},
        updateCalendarLoading: false,
        updateCalendarError: null,
      };

    case "RESET_ATTENDANCE_VIEW_DATA":
      return {
        ...state,
        attendances: [],
        attendancesLoading: false,
        attendancesError: null,
        employee: {},
        getEmployeeLoading: false,
        getEmployeeError: null,
        calendars: [],
        calendarsLoading: false,
        calendarsError: null,
      };

    case "REQUEST_CREATE_CALENDAR_HOLIDAY":
      return {
        ...state,
        request: action.payload.request,
        newCalendarHoliday: {},
        newCalendarHolidayLoading: true,
        newCalendarHolidayError: null,
      };
    case "CREATE_CALENDAR_HOLIDAY_SUCCESS":
      return {
        ...state,
        request: null,
        newCalendarHoliday: action.payload,
        newCalendarHolidayLoading: false,
        calendars: state.calendars.map((calendar) =>
          calendar.id === action.payload.calendarID
            ? {
                ...calendar,
                holidays: {
                  ...calendar.holidays,
                  items: [...(calendar.holidays?.items || []), action.payload],
                },
              }
            : calendar,
        ),
      };
    case "CREATE_CALENDAR_HOLIDAY_ERROR":
      return {
        ...state,
        request: null,
        newCalendarHolidayLoading: false,
        newCalendarHolidayError: action.error,
      };
    case "REQUEST_DELETE_CALENDAR_HOLIDAY":
      return {
        ...state,
        deletedHolidayId: null,
        deleteHolidayLoading: true,
        deleteHolidayError: null,
      };
    case "DELETE_CALENDAR_HOLIDAY_SUCCESS":
      return {
        ...state,
        deleteHolidayLoading: false,
        deletedHolidayId: action.payload.id,
        calendars: state.calendars.map((calendar) => ({
          ...calendar,
          holidays: {
            ...calendar.holidays,
            items: calendar.holidays.items.filter(
              (holiday) => holiday.id !== action.payload.id,
            ),
          },
        })),
      };
    case "DELETE_CALENDAR_HOLIDAY_ERROR":
      return {
        ...state,
        deleteHolidayLoading: false,
        deleteHolidayError: action.error,
      };
    case "CLEAR_CALENDAR_HOLIDAY":
      return {
        ...state,
        newCalendarHoliday: {},
        newCalendarHolidayLoading: false,
        newCalendarHolidayError: null,
        deletedHolidayId: null,
        deleteHolidayLoading: false,
        deleteHolidayError: null,
      };
    // A save abandoned mid-flight (its modal closed). Without a case here its
    // loading flag stayed on and the next open showed a spinning button.
    case "CANCEL_CREATE_BUSINESS_PARTNER":
      return {
        ...state,
        request: null,
        newPartnerLoading: false,
      };
    case "CANCEL_UPDATE_BUSINESS_PARTNER":
      return {
        ...state,
        request: null,
        updatePartnerLoading: false,
      };
    case "CANCEL_CREATE_BUSINESS_TRANSACTION":
      return {
        ...state,
        request: null,
        newTransactionLoading: false,
      };
    case "CANCEL_UPDATE_BUSINESS_TRANSACTION":
      return {
        ...state,
        request: null,
        submitLoading: false,
      };
    default:
      return state;
  }
};
